import { Center } from '@chakra-ui/react';

export const CONTROLS_SIZE = 32;
export const OPTIONS_SIZE = 50;

const getColumnSize = (percent: number, totalWidth?: number) => {
  if (!totalWidth) {
    return undefined;
  }
  return (totalWidth - CONTROLS_SIZE - OPTIONS_SIZE) * percent;
};

export const getColumns = (totalWidth?: number) => {
  return [
    {
      accessorKey: 'controls',
      header: <Center w={5}>#</Center>,
      accessory: true,
      size: CONTROLS_SIZE,
      sx: { pl: 1 },
    },
    {
      accessorKey: 'title',
      header: 'Title',
      sx: { pl: 0 },
      enableResizing: true,
      minSize: 40,
      size: getColumnSize(0.25, totalWidth),
    },
    {
      accessorKey: 'song',
      header: 'Song',
      size: getColumnSize(0.25, totalWidth),
      minSize: 52,
      enableResizing: true,
    },
    {
      accessorKey: 'note',
      header: 'Note',
      size: getColumnSize(0.25, totalWidth),
      minSize: 52,
      enableResizing: true,
    },
    {
      accessorKey: 'duration',
      header: 'Duration',
      size: getColumnSize(0.25, totalWidth),
      minSize: 76,
      enableResizing: true,
    },
    {
      accessorKey: 'gap',
      size: 0,
    },
  ];
};
